import { Fragment, memo, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import { useSelector } from "react-redux";
import { useWindowWidth } from "@react-hook/window-size";
import { Link } from "react-router-dom";
import Translate from "../../../../Components/Multilanguage/Translate";
import TrailerModal from "../../../../Components/Modals/TrailerModal";
import BannerUtil from "../util.jsx";
import playIcon from "../../../../assets/Images/play.png";
import { imageUrlCheck } from "../../../../utils/utils";

const NewBlockBanner = memo(({ data }) => {
  const themeSchemeDirection = '';
  const [toggler, setToggler] = useState(false);
  const [trailerLink, setTrailerLink] = useState();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const { replaceImage, trailerButtonHandle, playClickHandler } = BannerUtil();
  const windowWidth = useWindowWidth();
  const isMobileViewport = windowWidth <= 480;
  
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  return (
    <Fragment>
      <section className="new-block-banner">
        <div className="new-block-banner__wrapper">
          <Swiper
            key={themeSchemeDirection}
            dir={themeSchemeDirection}
            navigation={{
              prevEl: ".new-block-banner__button-prev",
              nextEl: ".new-block-banner__button-next",
            }}
            slidesPerView={1}
            modules={[Navigation, Autoplay]}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            centeredSlides={false}
            className="new-block-banner__swiper"
          >
            {data?.shows?.map((item, index) => {
              const bannerImage = isMobileViewport
                ? item?.banner_portrait || item?.banner
                : item?.banner;

              return (
              <SwiperSlide key={index}>
                <div className="new-block-banner__slide">
                  <div className="new-block-banner__background">
                    {imageUrlCheck(item?.banner || item?.logo) ? (
                      <img
                        src={bannerImage}
                        onError={(error) => replaceImage(error)}
                        alt="Banner"
                      />
                    ) : (
                      <img
                        src={`${process.env.REACT_APP_IMAGE_URL}${bannerImage}`}
                        onError={(error) => replaceImage(error)}
                        alt="Banner"
                      />
                    )}
                  </div>

                  <div className="new-block-banner__content">
                    <div className="new-block-banner__grid">
                      <div className="new-block-banner__col new-block-banner__col--left">
                        <div className="new-block-banner__button">
                          <div
                            className="new-block-banner__play-link"
                            onClick={() => playClickHandler(item)}
                          >
                            <img src={playIcon} alt="play" />
                          </div>
                        </div>

                        <h1 className="new-block-banner__title">
                          { (item?.image_title && imageUrlCheck(`${item.image_title}`)) ? (
                              <img src={`${item.image_title}`} alt={item.image_title || item.show_name} className="titleImage" />
                            ) : (
                              item?.show_name
                          )}
                        </h1>
                      </div>

                      {/* {item?.teaser_vanity_url && (
                        <div className="hero-banner__col hero-banner__col--right">
                          <div className="hero-banner__trailer">
                          <Link
                            to="#"
                            className="hero-banner__trailer-link"
                            tabIndex="0"
                          >
                            <svg
                              version="1.1"
                              viewBox="0 0 213.7 213.7"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                            <polygon
                              className="triangle"
                              fill="none"
                              strokeWidth="7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeiterlimit="10"
                              points="73.5,62.5 148.5,105.8 73.5,149.1 "
                            ></polygon>
                            <circle
                              className="circle"
                              fill="none"
                              strokeWidth="7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeiterlimit="10"
                              cx="106.8"
                              cy="106.8"
                              r="103.3"
                            ></circle>
                            </svg>
                            <span
                              className="hero-banner__trailer-text"
                              onClick={() => trailerButtonHandle(item?.teaser_vanity_url, setTrailerLink, setToggler, toggler)}
                            >
                              <Translate textKey={"watch_trailer"} />
                            </span>
                          </Link>
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
            })}

            <div className="new-block-banner__button-next">
              <i className="fa fa-chevron-right"></i>
            </div>
            <div className="new-block-banner__button-prev">
              <i className="fa fa-chevron-left"></i>
            </div>
          </Swiper>
        </div>
      </section>

      {toggler && trailerLink !== null && (
        <TrailerModal
          teaser={trailerLink}
          setIsTrailer={setToggler}
          appInfo={appInfo}
        />
      )}
    </Fragment>
  );
});

NewBlockBanner.displayName = NewBlockBanner;
export default NewBlockBanner;